import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "firebase/auth";
import mainImage from "../mainImage.png";
import app from "../db/firebase";
toast.configure();
function Home() {
  // useEffect(() => {
  //   app.auth().onAuthStateChanged(function (user) {
  //     if (user) {
  //       console.log(user);
  //     } else {
  //       console.log("prantho");
  //       // No user is signed in.
  //     }
  //   });
  // }, []);
  const [link, setlink] = useState("");
  const [error, seterror] = useState({
    text: "",
    status: false,
  });

  const [linkShort, setlinkShort] = useState("");
  const [loading, setloading] = useState(false);
  const shortner = async () => {
    if (link.length <= 0) {
      seterror({
        text: "Please Insert The Field!",
        status: true,
      });
      setloading(false);
      return false;
    }
    try {
      const url = `https://api.shrtco.de/v2/shorten?url=${ link }/very/long/link.html`;
      const res = await fetch(url);
      const result = await res.json();
      setlinkShort(result.result.full_short_link2);
      setloading(false);
      setlink("");
      seterror({
        text: "",
        status: false,
      });
    } catch (error) {
      setloading(false);
      toast.error("Some Problem Appear Please Try Again!");
      seterror({
        text: "Some Problem Appear Please Try Again!",
        status: true,
      });
    }
  };
  return (
    <motion.div exit={{ x: "-100vw" }} className="home">
      <div className="row">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{
            stiffness: "100",
            duration: 1,
          }}
          className="col l6 s12 homeInfo"
        >
          <h1 className="white-text">More than just</h1>
          <h1 className="white-text">shorter links</h1>
          <p>
            Build your brand's recognition and get detailed insights on how your
            links are performing.
          </p>
          <div className="shortner">
            <div className="row">
              <div className="col l9 s12">
                <input
                  type="url"
                  placeholder="Place Your Link Here"
                  onChange={(e) => setlink(e.target.value)}
                />
              </div>
              <div className="col l3 s12">
                <motion.button
                  onClick={() => {
                    setloading(true);
                    shortner();
                  }}
                  whileTap={{ outline: "1px solid white" }}
                >
                  {loading ? (
                    <motion.span
                      className="material-icons"
                      animate={{ rotate: [0,360] }}
                      transition={{
                        yoyo: Infinity,
                        ease:"circInOut"
                      }}
                    >
                      refresh
                    </motion.span>
                  ) : (
                    "Shorten It"
                  )}
                </motion.button>
              </div>
            </div>
          </div>
          {error.status ? <h5 className="red-text">{error.text}</h5> : ""}
          {linkShort.length > 0 ? (
            <div
              className="row white"
              style={{
                textAlign: "center",
                padding: "1rem",
                borderRadius: "5px",
              }}
            >
              <div className="col s12">
                <div className="link">
                  <h4>Link created! 😃</h4>
                  <a
                    href={linkShort}
                    target="_blank"
                    className="green-text text-center"
                  >
                    {linkShort}
                  </a>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </motion.div>
        <motion.div
          initial={{
            x: "200vw",
          }}
          animate={{
            x: 0,
            duration: 2,
          }}
          className="col l6 s12"
          style={{ padding: "1rem 0rem" }}
        >
          <img className="responsive-img" src={mainImage} />
        </motion.div>
      </div>
    </motion.div>
  );
}

export default Home;
